import { createApp } from 'vue';

import Search from '../components/general/search.vue';
import Filters from '../components/general/filters.vue';
import LeadCapturing from '../components/forms/lead-capturing.vue';

// Mounts optional Twig-rendered widgets only when the current template includes them.
function mountIfPresent(selector, options = {}) {
	const el = document.querySelector(selector);

	if (!el) {
		return;
	}

	const app = createApp(options);
	app.config.compilerOptions.whitespace = 'preserve';
	app.mount(el);
}

mountIfPresent('#lead-capturing-container', {
	components: {
		LeadCapturing
	}
});

mountIfPresent('#associations', {
	data() {
		return {
			associationToggle: 'residential'
		};
	}
});

mountIfPresent('#footer-cta', {
	components: {
		Search,
		Filters
	}
});
